// extracted by mini-css-extract-plugin
module.exports = {"avatarCircle":"style_avatarCircle__ihDMF","avatarCircleSize":"style_avatarCircleSize__Bt2d2"};